import { render, staticRenderFns } from "./ChartSettings.vue?vue&type=template&id=1078b0fd&scoped=true"
import script from "./ChartSettings.vue?vue&type=script&lang=js"
export * from "./ChartSettings.vue?vue&type=script&lang=js"
import style0 from "./ChartSettings.vue?vue&type=style&index=0&id=1078b0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078b0fd",
  null
  
)

export default component.exports